import Backbone from 'backbone'
import template from './dashboard-ai-assistant.hbs'
import aiResultCard from './dashboard-ai-result-card.hbs'
import aiAssistantConversation from './dashboard-ai-assistant-conversation.hbs'
import $ from 'jquery'
import globals from 'scoreboard/components/globals'
import TreeStream from 'scoreboard/components/tree-stream'
import aiResponse from './ai-response.hbs'

const DashboardAiAssistant = Backbone.View.extend({

	tag: 'section',

	className: 'dashboard-ai-assistant',

	events: {
		'click .generate': 'submit',
		'click .regenerate': 'submit'
	},

	initialize: function(options) {
		this.options = options || {}
		window.ai = this // for debugging. I have a TODO to remove it later
	},

	render: function() {
		this.loadingAnimation = $('<video/>', {
			class: 'ai-assistant-loading',
			autoplay: true,
			muted: true, // needed to autoplay in some browsers
			loop: true,
			src: globals.staticResourcePath + '/images3/ai-assistant-loading.mov'
		})

		this.$el.empty().append(template())
		this.mainContent = this.$('.main-content')

		// FIXME - show initial suggestions/examples
		this.appendNewAIConversation(true)
		this.submit({
			message: 'Hi, I’m an AI assistant that can securely help you create dashboards from your data. For example, here are some dashboards I could make:',
			initialRender: true
		})

		// I have a note to come back to this later and clean it up
		this.stream = new TreeStream({
			url: '/api/ai-assistant/example-dashboards',
			method: 'post'
		})
		// this.stream.on('loading', () => console.log('loading'))
		// this.stream.on('headers', headers => {
		// 	console.log('headers')
		// 	console.dir(headers)
		// })
		this.stream.on('data', data => {
			console.log('data')
			console.dir(data)
			if (data.type == 'error') {
				this.onError(data)
			}
		})
		this.stream._read()

		// $.post('/api/ai-assistant/test', response => {
		// 	this.removeLoadingAnimations()
		// 	console.log(response)
		// })

		return this
	},

	/**
	 * Remove any current loading animations
	 */
	removeLoadingAnimations: function() {
		this.$('.loading-animation').remove()
	},

	onError: function() {
		this.$('.ai-response').last()
			.removeClass('ai-returning-results')

		// will be fixed by https://github.com/SpiderStrategies/Scoreboard/issues/54509
		this.mainContent.append(aiResponse({
			aiTextResponse: 'Sorry, I’m having trouble understanding you. Please try again.'
		}))

		this.$('.regenerate').remove()
		this.removeLoadingAnimations()
	},

	/**
	 * Renders a response from the AI
	 */
	aiResponse: function() {
		// I have a note to clean this up
	},

	// I have a note to clean this up
	submit: function({message, initialRender}) {
		// FIXME - when sending requests to the AI, add the following class which
		// will put the controls in a disabled state.
		this.$el.addClass('is-submitting')

		if (initialRender) {
			this.$('.ai-response').addClass('ai-returning-results')
		} else {
			// setTimeout(() => {
			// 	this.appendNewAIConversation()
			// 	this.$('.ai-response').last().addClass('ai-returning-results')
			// 	this.updateResponseText('Ok, getting that for you now.')
			// 	this.scrollToNewest()
			// }, 500)
		}

		// setTimeout(() => {
		// 	// FIXME - After results are retrieved and displayed, remove
		// 	// the disabled states and show the results. Just using a timeout for now.
		// 	this.showResults(message)
		// }, 12000)
	},

	appendNewAIConversation: function(initialRender) {
		// FIXME - needs real messages
		let userPromptText = initialRender ? null : 'This is the text I typed and sent to the AI genie.'
		let aiAssistantConversationEl = aiAssistantConversation({
			userPromptText,
			aiTextResponse: 'Hi, I’m an AI assistant that can securely help you create dashboards from your data. For example, here are some dashboards I could make:',
			loadingAnimation: this.loadingAnimation[0].outerHTML
		})



		this.mainContent.append(aiAssistantConversationEl)
	},

	showResults: function(textResponse) {
		this.$el
			.removeClass('is-submitting')
			.addClass('is-showing-results')

		this.$('.ai-response').last()
			.removeClass('ai-returning-results')
			.find('.ai-assistant-loading') // Remove the loading animation
			.remove()

		// FIXME - Just showing 6 fake results for now. Need to show the actual results
		let lastBox = this.$('.ai-response').last()
		for (let i = 0; i < 6; i++) {
			lastBox.find('.ai-results-cards').append(aiResultCard({
				title: 'This is the title',
				description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
			}))
		}

		// FIXME - needs real text
		let response = textResponse ? textResponse : 'Here are some results for you.'
		this.updateResponseText(response)
		this.scrollToNewest()
	},

	scrollToNewest: function() {
		// Calculate the target position (scrollHeight) to scroll to
		const targetScrollHeight = this.mainContent[0].scrollHeight

		// Set the duration for smooth scrolling (in milliseconds)
		const duration = 800

		// Perform smooth scrolling animation
		this.mainContent.animate({ scrollTop: targetScrollHeight }, duration)
	},

	updateResponseText: function(text) {
		this.$('.ai-response').last().find('.ai-response').text(text)
	},

	autoRemove: true

})

export default DashboardAiAssistant


DashboardAiAssistant.__filename__ = 'dashboards/edit/dashboard-ai-assistant.js'
